// Central role helpers.
//
// The backend sends roles as strings ("admin", "user", "Community_user"). All
// role checks should go through these helpers instead of comparing the raw
// string, so behaviour stays consistent and new roles are easy to slot in.
//
// "Community_user" is treated exactly like a regular user on the user side: it
// passes every user-side check (`isUserSideRole`) and is blocked from admin
// routes (it is not an admin). If a Community_user ever needs distinct UI, gate
// it on `isCommunityUser` — the plumbing is already here.

export const ADMIN_ROLE = "admin";
export const USER_ROLE = "user";
export const COMMUNITY_USER_ROLE = "community_user";

const normalize = (role?: string | null): string =>
  (role ?? "").trim().toLowerCase();

// True for the admin role only.
export const isAdminRole = (role?: string | null): boolean =>
  normalize(role) === ADMIN_ROLE;

// True for the community user role only.
export const isCommunityUser = (role?: string | null): boolean =>
  normalize(role) === COMMUNITY_USER_ROLE;

// True for any role that should see the user-side app (regular users and
// community users). Use this wherever the code previously checked
// `role === "user"` so community users get the same UI.
export const isUserSideRole = (role?: string | null): boolean => {
  const r = normalize(role);
  return r === USER_ROLE || r === COMMUNITY_USER_ROLE;
};
